export enum Colors {
	Unknow = 0,
	None,
	Green,
	Orange,
	Red,
	Grey,
	LightBlue,
	DarkBlue,
}
